import React, { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import {
  AppShell, Container,
  Loader,
} from '@mantine/core';

import { Navbar } from '../components/navbar';
import { Header } from '../components/header';

export const AppShellLayout: React.FC = () => {
  const [navbarOpened, setNavbarOpened] = useState(false);

  return (
    <AppShell
      layout="alt"
      fixed
      navbarOffsetBreakpoint="md"
      navbar={(
        <Navbar
          navbarOpened={navbarOpened}
          setNavbarOpened={setNavbarOpened}
        />
      )}
      header={(
        <Header
          navbarOpened={navbarOpened}
          setNavbarOpened={setNavbarOpened}
        />
      )}
      styles={{
        main: {
          paddingTop: 110,
          paddingBottom: 110,
        },
      }}
    >
      <Suspense
        fallback={(
          <Container pt={100} ta={{ base: 'center', lg: 'left' }}>
            <Loader size="sm" color="gray" />
          </Container>
        )}
      >
        <Outlet />
      </Suspense>
    </AppShell>
  );
};
